import { ArtifactItemTransition, CreateArtifactItemTransition } from '../../types/artifactItems';
import { BaseService } from './BaseService';
import { API_ENDPOINTS } from './config';

export class TransitionService extends BaseService {
  static async getTransitionsByArtifact(
    artifactId: string,
    is_improvement?: boolean
  ): Promise<ArtifactItemTransition[]> {
    if (process.env.NODE_ENV === 'development') {
      console.log('[TransitionService] Fetching transitions for artifact:', artifactId);
    }
    const params: Record<string, string> = {};
    if (is_improvement !== undefined) {
      params.is_improvement = String(is_improvement);
    }
    const queryString = new URLSearchParams(params).toString();
    const url = queryString
      ? `${API_ENDPOINTS.ARTIFACTS.BY_ID(artifactId)}/transitions?${queryString}`
      : `${API_ENDPOINTS.ARTIFACTS.BY_ID(artifactId)}/transitions`;
    
    if (process.env.NODE_ENV === 'development') {
      console.log('[TransitionService] Using endpoint:', url);
    }
    try {
      const response = await this.get<{ transitions: ArtifactItemTransition[] } | ArtifactItemTransition[]>(url);
      
      // Handle both response formats: { transitions: [...] } or [...]
      const transitions = Array.isArray(response) 
        ? response 
        : (response as { transitions: ArtifactItemTransition[] })?.transitions || [];
      
      if (process.env.NODE_ENV === 'development') {
        console.log('[TransitionService] Processed transitions:', transitions.length);
      }
      return transitions;
    } catch (error) {
      console.error('[TransitionService] Error fetching transitions:', error);
      return [];
    }
  }

  static async createTransition(
    transition: Partial<ArtifactItemTransition>
  ): Promise<ArtifactItemTransition> {
    console.log('[TransitionService] Creating transition:', transition);
    const artifactId = transition.artifact_ref;
    if (!artifactId) {
      throw new Error('artifact_ref is required to create a transition');
    }
    return this.post<ArtifactItemTransition>(
      API_ENDPOINTS.ARTIFACTS.TRANSITIONS(artifactId),
      transition as unknown as Record<string, unknown>
    );
  }

  static async create(
    artifactId: string,
    transition: CreateArtifactItemTransition
  ): Promise<ArtifactItemTransition> {
    console.log('[TransitionService] Creating transition:', transition);
    return this.post<ArtifactItemTransition>(
      API_ENDPOINTS.ARTIFACTS.TRANSITIONS(artifactId),
      transition as unknown as Record<string, unknown>
    );
  }

  static async updateTransition(
    transitionId: string,
    transition: Partial<ArtifactItemTransition>
  ): Promise<ArtifactItemTransition> {
    console.log('[TransitionService] Updating transition:', transitionId);
    console.log(
      '[TransitionService] Using endpoint:',
      `${API_ENDPOINTS.ARTIFACTS.UPDATE_TRANSITION(transition.artifact_ref!, transitionId)}`
    );
    return this.put<ArtifactItemTransition>(
      API_ENDPOINTS.ARTIFACTS.UPDATE_TRANSITION(transition.artifact_ref!, transitionId),
      transition as unknown as Record<string, unknown>
    );
  }

  static async deleteTransition(transitionId: string, artifactId: string): Promise<void> {
    console.log('[TransitionService] Deleting transition:', transitionId);
    return this.delete(API_ENDPOINTS.ARTIFACTS.DELETE_TRANSITION(artifactId, transitionId));
  }

  static async getTransitionsByProcess(processId: string): Promise<ArtifactItemTransition[]> {
    console.log('[TransitionService] Fetching transitions for process:', processId);
    try {
      const response = await this.get<{ transitions: ArtifactItemTransition[] }>(
        `${API_ENDPOINTS.ARTIFACTS.BASE}transitions?process_ref=${processId}`
      );
      return response?.transitions || [];
    } catch (error) {
      console.error('[TransitionService] Error fetching transitions by process:', error);
      return [];
    }
  }
}
